import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const styles = {
  container: {
    height: "100vh",
    backgroundColor: "#111",
    backgroundImage: "url('bg-pattern.svg')",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 2,
  },
  title: {
    fontWeight: 600,
    textShadow: "2px 2px 2px #222",
  },
  subtitle: {
    fontWeight: 400,
    textShadow: "1px 1px 1px #222",
    textAlign: "center",
    width: "80%",
  },
  button: {
    marginTop: 3,
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
};

export default function Intro() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Box sx={styles.container}>
        <Typography
          variant={isSmallScreen ? "h4" : "h2"}
          color="#fff"
          sx={styles.title}
          gutterBottom
        >
          Corrie Stoddard
        </Typography>
        <Typography
          variant={isSmallScreen ? "h6" : "h4"}
          color="#eee"
          sx={styles.subtitle}
        >
          I build beautiful, responsive websites from front to back, always
          putting the user experience first.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={styles.button}
          href="#portfolio"
          aria-label="View My Work"
        >
          <Typography variant="button"> View My Work </Typography>
        </Button>
      </Box>
    </>
  );
}
